import React, { FC } from 'react'
import CreatableSelect from 'react-select/creatable'
import Select, { ValueType, OptionTypeBase } from 'react-select'
import { BLACK } from '../contants'

type Value = {
  label: string
  value: string
}
type Values = Array<Value>

interface ICustomSelect {
  creatable?: boolean
  options?: Values
  values: ValueType<OptionTypeBase> | string
  placeholder?: string
  single?: boolean
  getOptionLabel?: any
  getOptionValue?: any
  handleChange: (values: any) => void
}
const CustomSelect: FC<ICustomSelect> = ({
  creatable,
  options = [],
  values,
  placeholder,
  handleChange,
  single,
  ...otherProps
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: 'none',
      // border: 'none',
      minHeight: '50px',
      border: state.isFocused ? 0 : 0,
      // This line disable the blue border
      boxShadow: state.isFocused ? 0 : 0,
      '&:hover': {
        border: state.isFocused ? 0 : 0
      }
    }),
    multiValue: provided => ({
      ...provided,
      background: '#ECEFF5',
      padding: 8
    }),
    singleValue: provided => ({
      ...provided,
      fontSize: 16,
      margin: 0,
      color: BLACK
    }),
    multiValueLabel: provided => ({
      ...provided,
      fontSize: 16
    }),
    placeholder: provided => ({
      ...provided,
      fontSize: 16
    }),
    valueContainer: provided => ({
      ...provided,
      padding: single ? '15px 20px' : '4px'
    }),
    menu: provided => ({
      ...provided,
      zIndex: 10,
      top: 'auto',
      bottom: '100%'
    }),
    input: provided => ({
      ...provided,
      margin: 0,
      padding: 0,
      fontSize: 16,
      color: BLACK
    })
  }

  const props = {
    styles: customStyles,
    isMulti: !single,
    placeholder: placeholder,
    onChange: handleChange,
    options: options,
    value: values
  }

  return creatable ? (
    <CreatableSelect {...props} {...otherProps} />
  ) : (
    <Select {...props} {...otherProps} />
  )
}

export default CustomSelect
